import { summarize } from '../lib/status';
import { useAppData } from '../store';

export default function NothingFallsThroughSummary() {
  const { obligations, remindersByObligation } = useAppData();
  const summary = summarize(obligations, remindersByObligation);

  if (summary.total === 0) return null;

  return (
    <section className="nft-summary card">
      <h2>Nothing Falls Through</h2>
      <p className="muted">
        You have {summary.total} active obligation{summary.total === 1 ? '' : 's'}.
      </p>
      <div className="nft-summary-rows">
        <div className="nft-row ok">
          <span className="nft-row-value">✓ {summary.upToDate}</span>
          <span className="nft-row-label">Up to date</span>
        </div>
        <div className="nft-row due-soon">
          <span className="nft-row-value">⚠ {summary.dueSoon}</span>
          <span className="nft-row-label">Due in 30 days</span>
        </div>
        <div className="nft-row overdue">
          <span className="nft-row-value">🔴 {summary.overdue}</span>
          <span className="nft-row-label">Overdue</span>
        </div>
      </div>
    </section>
  );
}
